module.exports = __webpack_public_path__ + "static/media/Plano1.80fc880e.jpg";